import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { scale110, scale130, spaceXXL, scale150 } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import type { ProductBenefitsProps } from './product-benefits';

const StyledSubHeadline = styled(BodyCopy)`
  font-size: ${scale110};
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    font-size: ${scale130};
    margin-bottom: ${scale150};
  }
`;

export const SubHeadline: React.FC<ProductBenefitsProps> = ({ product }) => {
  return (
    <StyledSubHeadline size="small" sizeConfined="large">
      <FormattedMessage
        id={
          product === 'projobs'
            ? `UPSELL_LOGGED_OUT_PAGE_PRODUCTS_SUBHEADLINE_1`
            : `UPSELL_LOGGED_OUT_PAGE_PRODUCTS_SUBHEADLINE_2`
        }
      />
    </StyledSubHeadline>
  );
};
